import { AfterViewInit, Component, OnDestroy, OnInit, viewChild } from '@angular/core';
import { ModalComponent } from '@src/app/components/modal/modal.component';
import { ModalService } from '@src/app/services/modal/modal.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-redirect-modal',
  templateUrl: './redirect-modal.component.html',
  styleUrls: ['./redirect-modal.component.scss'],
  standalone: false,
})
export class RedirectModalComponent implements AfterViewInit, OnDestroy {
  private _window: Window = window;
  public redirectUrl: URL;

  private readonly _modalComponent = viewChild<ModalComponent>('modalComponent');
  private _componentDestroyed$: Subject<void> = new Subject();

  constructor(
    private _modalService: ModalService,
  ) {
  }

  ngAfterViewInit() {
    this._modalComponent().getModalArg('url')
      .pipe(takeUntil(this._componentDestroyed$))
      .subscribe({
        next: (url: URL) => {
          this.redirectUrl = url;
        },
        error: (_) => {
        },
      });
  }

  /**
   * OnDestroy close subscriptions
   */
  ngOnDestroy(): void {
    this._componentDestroyed$.next();
    this._componentDestroyed$.complete();
  }

  redirect(): void {
    this._window.open(this.redirectUrl.toString(), '_blank');
    this.close();
  }

  /**
   * close the modal
   */
  public close(): void {
    this.redirectUrl = undefined;
    this._modalService.close('redirect-modal');
  }
}
